/**
 * Thrive's Zendesk bug-report form, scoped to HealthOS via the ticket form's
 * product field. Shared rather than per-client so every surface that offers
 * "Report a bug" sends members to the same queue.
 */
export const THRIVE_REPORT_BUG_URL = "https://support.thriveglobal.com/hc/en-us/requests/new?ticket_form_id=51634855886099&tf_51634776854547=healthos";
//# sourceMappingURL=support-links.js.map